import {isTenantAdmin, isTenantHost} from './is-tenant-admin';

export const USER_PRICING_PATH = '/pricing';
export const TENANT_PRICING_PATH = '/tenant/pricing';

// Re-export for backwards compatibility
export {isTenantHost};

export function getPricingPath(): string {
  // Only tenant admins should use tenant pricing path
  // Regular users (even on tenant domains) should use user pricing path
  return isTenantAdmin() ? TENANT_PRICING_PATH : USER_PRICING_PATH;
}
